/// <reference types="vite-plugin-svgr/client" />

import { useContext } from 'react';
import { Heading, Paragraph } from '@alto-avios/alto-ui';

import BaLogo from '../../assets/ba-circle-logo.svg?react';
import { CMSProviderContext } from '../services/content';

import styles from './MyAccountDetailsCard.module.css';

export interface MyAccountProps {
  balance?: number;
  membershipNumber: string;
}

export const MyAccountDetailsCard = ({ balance, membershipNumber }: MyAccountProps) => {
  const { header } = useContext(CMSProviderContext);
  const { mobileAccount } = header.data;

  return (
    <div className={styles.userDetailsCard} data-testid="my-account-details-card">
      <Paragraph foregroundColor="accentOnVibrant" size="xs">
        {mobileAccount.balanceLabel}
      </Paragraph>
      <Heading as="h6" size="lg" foregroundColor="accentOnVibrant">
        {balance?.toLocaleString('en-GB') ?? '-'}
      </Heading>
      <div className={styles.partnerRow}>
        <div className={styles.partnerIcon}>
          <BaLogo />
        </div>
        <div className={styles.partnerMembership}>
          <Paragraph foregroundColor="accentOnVibrant" size="xs">
            {mobileAccount.membershipNumberLabel}
          </Paragraph>
          <p className={styles.membershipNumber}>{membershipNumber}</p>
        </div>
      </div>
    </div>
  );
};
